import * as types from './orderActionTypes';

export const getOrderRequest = (payload) => 
({ type: types.GET_ORDER_REQUEST, payload });
export const getOrderSuccess = (payload) => 
({ type: types.GET_ORDER_SUCCESS, payload });
export const getOrderError = (payload) => 
({ type: types.GET_ORDER_ERROR, payload });

export const addOrderRequest = (payload) => 
({ type: types.ADD_ORDER_REQUEST, payload });
export const addOrderSuccess = (payload) => 
({ type: types.ADD_ORDER_SUCCESS, payload });
export const addOrderError = (payload) => 
({ type: types.ADD_ORDER_ERROR, payload });

export const updateOrderRequest = (payload) => 
({ type: types.UPDATE_ORDER_REQUEST, payload });
export const updateOrderSuccess = (payload) => 
({ type: types.UPDATE_ORDER_SUCCESS, payload });
export const updateOrderError = (payload) => 
({ type: types.UPDATE_ORDER_ERROR, payload });

export const deleteOrderRequest = (payload) => 
({ type: types.DELETE_ORDER_REQUEST, payload });
export const deleteOrderSuccess = (payload) => 
({ type: types.DELETE_ORDER_SUCCESS, payload });
export const deleteOrderError = (payload) => 
({ type: types.DELETE_ORDER_ERROR, payload });

export const getOrderDetailsRequest = (payload) => 
({ type: types.GET_ORDER_DETAILS_REQUEST, payload });
export const getOrderDetailsSuccess = (payload) => 
({ type: types.GET_ORDER_DETAILS_SUCCESS, payload });
export const getOrderDetailsError = (payload) => 
({ type: types.GET_ORDER_DETAILS_ERROR, payload });

export const orderActionRequest = (payload) => 
({ type: types.ORDER_ACTION_REQUEST, payload });
export const orderActionSuccess = (payload) => 
({ type: types.ORDER_ACTION_SUCCESS, payload });
export const orderActionError = (payload) => 
({ type: types.ORDER_ACTION_ERROR, payload }); 

export const updateSwapStockRequest = (payload) =>
({ type: types.UPDATE_SWAP_STOCK_REQUEST, payload });
export const updateSwapStockSuccess = (payload) =>
({ type: types.UPDATE_SWAP_STOCK_SUCCESS, payload });
export const updateSwapStockError = (payload) =>
({ type: types.UPDATE_SWAP_STOCK_ERROR, payload });

export const updateSwapShipmentRequest = (payload) =>
({ type: types.UPDATE_SWAP_SHIPMENT_REQUEST, payload });
export const updateSwapShipmentSuccess = (payload) =>
({ type: types.UPDATE_SWAP_SHIPMENT_SUCCESS, payload });
export const updateSwapShipmentError = (payload) =>
({ type: types.UPDATE_SWAP_SHIPMENT_ERROR, payload });